// CSV Upload Status for shore users, vessels, crew users
export const CSV_UPLOAD_STATUS = {
    NOT_STARTED: 'NotStarted',
    IN_PROGRESS: 'InProgress',
    PARTIAL_SUCCESS: 'PartialSuccess',
    SUCCESS: 'Success',
    ERROR: 'Error',
    ERROR_BAD_CSV_FORMAT: 'ErrorBadCsvFormat',
} as const;

export const CSV_TYPE = {
    SHORE_USER: 'ShoreUser',
    CREW_USER: 'CrewUser',
    VESSEL: 'Vessel',
} as const;

// CSV Upload Polling Constants
export const CSV_UPLOAD_POLLING_INTERVAL_MS = 2_000;
export const MAX_NOT_STARTED_POLLS = 5;
